import FolderIcon from '@mui/icons-material/Folder';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';

import { isLast } from '../../../utils/utils';

const FilePath = ({ folderChain, onChangeFolder }) => {
  const moveInChain = (index) => {
    const newChainLocation = folderChain.slice(0, index + 1);
    onChangeFolder(newChainLocation);
  };

  return (
    <Box sx={{ display: 'flex', mb: 1 }}>
      {folderChain.map((item, i) => (
        <Box key={item.id} sx={{ display: 'flex', alignItems: 'center' }}>
          {i === 0 ? (
            <FolderIcon fontSize="small" sx={{ mr: 0.5 }} />
          ) : (
            <KeyboardArrowRight />
          )}
          <Button
            color="inherit"
            disabled={isLast(folderChain, i)}
            variant="text"
            size="small"
            sx={{ minWidth: '0', textTransform: 'none' }}
            onClick={() => moveInChain(i)}
          >
            <Typography component="span" variant="body2" fontSize="1.1em">
              {item.name}
            </Typography>
          </Button>
        </Box>
      ))}
    </Box>
  );
};

FilePath.propTypes = {
  folderChain: PropTypes.array.isRequired,
  onChangeFolder: PropTypes.func.isRequired,
};

export default FilePath;
